import { ChatMessageManager, Params as ChatMessageManagerParams } from "../chunk-manager"

declare global {
  interface Window {
    initChat: () => void
    setChatMessageManager: (params: ChatMessageManagerParams | null) => void
  }
}

window.initChat = () => {
  const html = document.documentElement
  if (!html) {
    return
  }

  window.chatMessageManager = null

  document.addEventListener("DOMContentLoaded", () => window.initSSE())
}

window.setChatMessageManager = (params) => {
  if (!params) {
    window.chatMessageManager = null
    return
  }

  window.chatMessageManager = new ChatMessageManager(params)
}